import { Layer, VectorSource } from 'mapbox-gl';
import { primary, neutral, pink, yellow } from '../../style/colors';
import {
  IEtagerByggehojdeFilter,
  EtagerByggeHojdeFilter,
  IBygOmfangFilter,
  BygOmfangFilter,
} from '../../store/interfaces/state';
export const PlanSource: VectorSource = {
  type: 'vector',
  tiles: ['http://planvector.cust.septima.dk/plandk2/3857/{z}/{x}/{y}.pbf'],
};

const PlanLayerCommon: Layer = {
  id: 'PlanLayerCommon', // overwrite
  type: 'fill',
  source: 'lokalplan',
  'source-layer': 'plandk2',
  layout: {
    visibility: 'visible',
  },
  paint: {
    'fill-outline-color': neutral[500],
    'fill-opacity': 0.6,
  },
  filter: ['all'],
};

export const getGenerelAnvendelsePaint = () => {
  return {
    ...PlanLayerCommon.paint,
    // 'fill-color': primary[600],
    'fill-color': [
      'match',
      ['get', 'anvgen'],
      // Bolig
      11,
      '#DFA480',

      // Blandet bolid og erhverv
      21,
      '#AC596C',

      // Erhverv
      31,
      '#8DC9D7',

      // Centerområde
      41,
      '#DA87B0',

      // Rekreativt område
      51,
      '#D2E8B4',

      // Sommerhusområde
      61,
      '#F7DDAE',

      // Offentlig formål
      71,
      '#EEE778',

      // Teknisk anlæg
      81,
      '#9AA2C8',

      // Landområde
      91,
      '#95D5B2',

      // Andet
      96,
      '#C5C4C8',

      // default / Ukendt
      '#BECAD4',
    ],
  };
};
export const getPlanensAlderPaint = (fromYear, toYear) => {
  return {
    ...PlanLayerCommon.paint,
    'fill-color': [
      'interpolate',
      ['linear'],
      ['get', 'datoikraft'],
      fromYear * 10000,
      primary[400],
      (toYear + 1) * 10000,
      pink[800],
    ],
  };
};

export const getEtagerByggeHojdePaint = (
  etagerByggeHojdeFilter: IEtagerByggehojdeFilter
) => {
  const { filter } = etagerByggeHojdeFilter;
  return {
    ...PlanLayerCommon.paint,
    'fill-color': [
      'interpolate',
      ['linear'],
      [
        'get',
        etagerByggeHojdeFilter.selectedFilter ===
        EtagerByggeHojdeFilter.antalEtager
          ? 'max_maxetage'
          : 'max_maxbhjd',
      ],
      filter[0],
      primary[400],
      filter[1],
      pink[800],
    ],
  };
};
export const getBygOmfangPaint = (bygOmfangFilter: IBygOmfangFilter) => {
  const { filter } = bygOmfangFilter;
  let filterField = '';
  if (bygOmfangFilter.selectedFilter === BygOmfangFilter.bebyggelsesProcent) {
    filterField = 'max_bygpct';
  } else if (bygOmfangFilter.selectedFilter === BygOmfangFilter.etageMeter) {
    filterField = 'max_m3_m2h';
  } else {
    //rumfang
    filterField = 'max_m3_m2';
  }
  return {
    ...PlanLayerCommon.paint,
    'fill-color': [
      'interpolate',
      ['linear'],
      ['get', filterField],
      filter[0],
      primary[400],
      filter[1],
      pink[800],
    ],
  };
};
export const LokalPlan: Layer = {
  ...PlanLayerCommon,
  id: 'lokalplan',
  paint: getGenerelAnvendelsePaint() as any,
  filter: [
    ...PlanLayerCommon.filter,
    ['all', ['==', 'object_type', 'lokalplan'], ['==', 'aktuel', true]],
  ],
};
export const LokalPlanHistorisk: Layer = {
  ...PlanLayerCommon,
  id: 'lokalplan-historisk',
  paint: {
    'fill-outline-color': pink[500],
    'fill-opacity': 0,
  },
  filter: [
    ...PlanLayerCommon.filter,
    [
      'all',
      ['==', 'object_type', 'lokalplan'],
      ['==', 'aktuel', false],
      ['==', 'planid', ''],
    ],
  ],
};
export function GetFilter(
  layerName,
  toggledAnvgens: Array<number>,
  toggledAnvspecs: Array<number>,
  planAlderFilter: Array<number>,
  bygOmfang: IBygOmfangFilter = {
    selectedFilter: BygOmfangFilter.bebyggelsesProcent,
    filter: [0, 100],
  },
  etagerByggeHojde: IEtagerByggehojdeFilter = {
    selectedFilter: EtagerByggeHojdeFilter.byggeHojde,
    filter: [1, 100],
  }
) {
  let anvgens: Array<any> = [
    'match',
    ['get', 'anvgen'],
    toggledAnvgens,
    true,
    false,
  ];
  if (toggledAnvgens.indexOf(0) > -1) {
    anvgens = [
      'any',
      ['match', ['get', 'anvgen'], toggledAnvgens, true, false],
      ['!=', ['typeof', ['get', 'anvgen']], 'number'],
    ];
  }
  const fromYear = planAlderFilter[0] > 1970 ? planAlderFilter[0] * 10000 : 0;
  const fromYearFilter = ['>', ['get', 'datoikraft'], fromYear];
  const toYear = (planAlderFilter[1] + 1) * 10000;
  const toYearFilter = ['<', ['get', 'datoikraft'], toYear];

  const [minBygOmfangFilter, maxBygOmfangFilter] = bygOmfang.filter;
  const bygOmfangFilter = [];
  if (bygOmfang.selectedFilter === BygOmfangFilter.bebyggelsesProcent) {
    if (minBygOmfangFilter > 0) {
      bygOmfangFilter.push(['>', ['get', 'max_bygpct'], minBygOmfangFilter]);
    }
    if (maxBygOmfangFilter < 100) {
      bygOmfangFilter.push(['<', ['get', 'max_bygpct'], maxBygOmfangFilter]);
    }
  }
  if (bygOmfang.selectedFilter === BygOmfangFilter.etageMeter) {
    if (minBygOmfangFilter > 0) {
      bygOmfangFilter.push(['>', ['get', 'max_m3_m2h'], minBygOmfangFilter]);
    }
    if (maxBygOmfangFilter < 10) {
      bygOmfangFilter.push(['<', ['get', 'max_m3_m2h'], maxBygOmfangFilter]);
    }
  }
  if (bygOmfang.selectedFilter === BygOmfangFilter.rumfang) {
    if (minBygOmfangFilter > 0) {
      bygOmfangFilter.push(['>', ['get', 'max_m3_m2'], minBygOmfangFilter]);
    }
    if (maxBygOmfangFilter < 30) {
      bygOmfangFilter.push(['<', ['get', 'max_m3_m2'], maxBygOmfangFilter]);
    }
  }

  const [minEtagerByggeHojde, maxEtagerByggeHojde] = etagerByggeHojde.filter;
  const byggehojdeFilter = [];
  if (etagerByggeHojde.selectedFilter === EtagerByggeHojdeFilter.byggeHojde) {
    if (minEtagerByggeHojde > 1) {
      byggehojdeFilter.push(['>', ['get', 'max_maxbhjd'], minEtagerByggeHojde]);
    }
    if (maxEtagerByggeHojde < 100) {
      byggehojdeFilter.push(['<', ['get', 'max_maxbhjd'], maxEtagerByggeHojde]);
    }
  }

  const maxAntalEtagerFilter = [];
  if (
    etagerByggeHojde.selectedFilter === EtagerByggeHojdeFilter.antalEtager &&
    (minEtagerByggeHojde > 0 || maxEtagerByggeHojde < 10)
  ) {
    if (minEtagerByggeHojde > 0) {
      byggehojdeFilter.push([
        '>',
        ['get', 'max_maxetage'],
        minEtagerByggeHojde,
      ]);
    }
    if (maxEtagerByggeHojde < 10) {
      byggehojdeFilter.push([
        '<',
        ['get', 'max_maxetage'],
        maxEtagerByggeHojde,
      ]);
    }
  }

  const anvspecFilter = [];
  if (toggledAnvspecs.length > 0) {
    toggledAnvspecs.forEach(anvspec => {
      anvspecFilter.push([
        'match',
        ['get', `anvspec_${anvspec}`],
        't',
        true,
        false,
      ]);
    });
  }
  const filter = [
    ...[
      'all',
      ['match', ['get', 'object_type'], layerName, true, false],
      ['==', ['get', 'aktuel'], true],
      anvgens,
      fromYearFilter,
      toYearFilter,
    ],
    ...anvspecFilter,
    ...bygOmfangFilter,
    ...byggehojdeFilter,
    ...maxAntalEtagerFilter,
  ];
  return toggledAnvgens.length ? filter : ['==', 'planid', ''];
}
export const LokalPlanDelOmraade: Layer = {
  ...PlanLayerCommon,
  id: 'lokalplandelomraade',
  paint: {
    ...PlanLayerCommon.paint,
    'fill-color': pink[600],
    // 'fill-opacity': 0.3,
    // 'fill-opacity': 0.1,
    'fill-opacity': 0,
  },
  filter: [
    ...PlanLayerCommon.filter,
    ['==', 'object_type', 'lokalplandelomraade'],
  ],
};
export const Byggefelt: Layer = {
  ...PlanLayerCommon,
  id: 'byggefelt',
  paint: {
    ...PlanLayerCommon.paint,
    'fill-color': yellow[600],
    // 'fill-opacity': 0.3,
    // 'fill-opacity': 0.1,
    'fill-opacity': 0,
  },
  filter: [...PlanLayerCommon.filter, ['==', 'object_type', 'byggefelt']],
};

export const SelectedLokalPlan: Layer = {
  ...PlanLayerCommon,
  id: 'lokalplan-selected',
  paint: {
    ...PlanLayerCommon.paint,
    'fill-opacity': 0.3,
    'fill-color': primary[700],
  },
  filter: [
    ...PlanLayerCommon.filter,
    ['==', 'object_type', 'lokalplan'],
    ['==', 'planid', ''],
  ],
};
export const SelectedLokalPlanHistorisk: Layer = {
  ...PlanLayerCommon,
  id: 'lokalplan-historisk-selected',
  paint: {
    ...PlanLayerCommon.paint,
    'fill-opacity': 0.6,
    'fill-color': yellow[900],
  },
  filter: [
    ...PlanLayerCommon.filter,
    ['==', 'object_type', 'lokalplan'],
    ['==', 'planid', ''],
  ],
};
export const SelectedLokalPlanDelOmraade: Layer = {
  ...PlanLayerCommon,
  id: 'lokalplandelomraade-selected',
  type: 'line',
  paint: {
    'line-color': pink[700],
    'line-width': 2,
    'line-dasharray': [2, 1],
  },
  filter: [...PlanLayerCommon.filter, ['==', 'planid', '']],
};
export const SelectedByggefelt: Layer = {
  ...PlanLayerCommon,
  id: 'byggefelt-selected',
  type: 'line',
  paint: {
    'line-color': yellow[700],
    'line-width': 2,
    'line-dasharray': [2, 1],
  },
  filter: [...PlanLayerCommon.filter, ['==', 'planid', '']],
};

export const HoveredLokalPlan: Layer = {
  ...PlanLayerCommon,
  id: 'lokaplan-hovered',
  type: 'line',
  paint: {
    'line-color': primary[700],
    'line-width': 4,
  },
  filter: [
    ...PlanLayerCommon.filter,
    ['==', 'object_type', 'lokalplan'],
    ['==', 'planid', ''],
  ],
};

export const HoveredLokalPlanDelOmraade: Layer = {
  ...PlanLayerCommon,
  id: 'lokalplandelomraade-hovered',
  paint: {
    ...PlanLayerCommon.paint,
    'fill-opacity': 0.8,
    'fill-color': pink[600],
  },
  filter: [...PlanLayerCommon.filter, ['==', 'planid', '']],
};
export const HoveredByggefelt: Layer = {
  ...PlanLayerCommon,
  id: 'byggefelt-hovered',
  paint: {
    ...PlanLayerCommon.paint,
    'fill-opacity': 0.8,
    'fill-color': yellow[600],
  },
  filter: [...PlanLayerCommon.filter, ['==', 'planid', '']],
};
